// ===============================
// All-in-one Script (Countdown + Redirect + Intro Modal + Video + Image Modal)
// ===============================
// - 初回アクセス時刻を localStorage に保存し、"初回日から2日目の00:00:00(ローカル)" でカウント終了
// - 終了時は /pages/campaign-ended にリダイレクト（?nojump で抑止 / ?expireNow で即終了テスト）
// - ロゴ → イントロモーダル → 閉じる/動画終了でファイナルビュー表示
// - ループ画像クリックで拡大モーダル
document.addEventListener('DOMContentLoaded', () => {
  // ====== 設定（必要に応じて変更）======
  const REDIRECT_URL  = '/pages/campaign-ended';
  const STORAGE_KEY   = 'initialAccessMs'; // キャンペーンが変わるたびにキーも変えるとリセット不要
  const DUE_DAYS_AFTER_FIRST_VISIT = 3;    // 初回から何日後の"0時"で締切にするか
  const INTRO_DELAY_MS = 2500;             // ロゴ→イントロ表示までのディレイ
  const INTRO_CLOSE_FADE_MS = 600;         // イントロ閉じる時の余韻
  // =====================================

  // すでに遷移先にいるなら無限リダイレクト回避
  const normalizePath = (p) => p.replace(/\/+$/, '');
  const onTargetPage  = normalizePath(location.pathname) === normalizePath(REDIRECT_URL);

  // テスト用URLパラメータ
  const params    = new URLSearchParams(location.search);
  const NOJUMP    = params.has('nojump');     // 終了しても遷移しない
  const EXPIRENOW = params.has('expireNow');  // 即終了扱い

  // ========== カウントダウン ==========
  // 初回アクセス時刻（ローカルのエポック）を保存
  let initialMs = Number(localStorage.getItem(STORAGE_KEY));
  if (!initialMs) {
    initialMs = Date.now();
    localStorage.setItem(STORAGE_KEY, String(initialMs));
  }
  const initial = new Date(initialMs);

  // 初回“日”から見て DUE_DAYS_AFTER_FIRST_VISIT 日目の 00:00:00（ローカル）
  const countdownTarget = new Date(
    initial.getFullYear(),
    initial.getMonth(),
    initial.getDate() + DUE_DAYS_AFTER_FIRST_VISIT,
    0, 0, 0, 0
  );
  if (EXPIRENOW) countdownTarget.setTime(Date.now());

  // 要素取得（存在しなくても落ちないように）
  const $  = (s) => document.querySelector(s);
  const $$ = (s) => Array.from(document.querySelectorAll(s));

  // カウントダウンの数値が入る要素
  const dayEl  = $('.countdown .item:nth-child(1) .value');
  const hourEl = $('.countdown .item:nth-child(2) .value');
  const minEl  = $('.countdown .item:nth-child(3) .value');
  const secEl  = $('.countdown .item:nth-child(4) .value');

  const pad2 = (n) => String(n).padStart(2, '0');

  function tick() {
    const diff = countdownTarget - Date.now();

    if (diff <= 0) {
      clearInterval(timer);
      // 表示を0に（任意）
      if (dayEl)  dayEl.textContent  = '0';
      if (hourEl) hourEl.textContent = '00';
      if (minEl)  minEl.textContent  = '00';
      if (secEl)  secEl.textContent  = '00';

      if (!onTargetPage && !NOJUMP) {
        // 余韻を入れたいなら setTimeout(() => location.assign(REDIRECT_URL), 800)
        location.assign(REDIRECT_URL);
      }
      return;
    }

    if (dayEl)  dayEl.textContent  = Math.floor(diff / 864e5);               // 1日=86400000
    if (hourEl) hourEl.textContent = pad2(Math.floor(diff % 864e5 / 36e5));  // 1時間=3600000
    if (minEl)  minEl.textContent  = pad2(Math.floor(diff % 36e5 / 6e4));    // 1分=60000
    if (secEl)  secEl.textContent  = pad2(Math.floor(diff % 6e4 / 1e3));     // 1秒=1000
  }
  const timer = setInterval(tick, 1000);
  tick();

  // ========== イントロ/ファイナル/動画 ==========
  const IV           = $('#initialView');      // ロゴ等の最初の画面
  const introModal   = $('#introContainer');   // イントロのコンテナ（オーバーレイ）
  const finalView    = $('#finalView');        // 最終画面
  const video        = $('#introVideo');       // プロモ動画
  const videoWrapper = $('#videoWrapper');     // 動画ラッパ（クリックで再生/一時停止トグル）
  const closeBtn     = $('#closeBtn');         // ×ボタン
  const watchNowBtn  = $('#watchNowBtn');      // Watch now ボタン

  // ロゴ表示のあとイントロを開く
  if (IV && introModal) {
    setTimeout(() => {
      IV.style.display = 'none';
      introModal.classList.add('active');
    }, INTRO_DELAY_MS);
  }

  // 動画の再生/停止
  function togglePlay() {
    if (!video) return;
    if (video.paused) video.play().catch(() => {/* ブラウザのポリシーで失敗しても無視 */});
    else video.pause();
  }
  if (videoWrapper) videoWrapper.addEventListener('click', togglePlay);
  if (video)        video.addEventListener('click', togglePlay);

  // イントロを閉じ → ファイナルビューへ
  function openFinalView() {
    if (finalView) finalView.classList.add('active');
    setTimeout(() => {
      if (introModal) introModal.classList.remove('active');
      if (video) video.pause();
    }, INTRO_CLOSE_FADE_MS);
  }

  // 閉じる／動画終了／背景クリック
  if (video)     video.addEventListener('ended', openFinalView);
  if (closeBtn)  closeBtn.addEventListener('click', openFinalView);
  if (introModal) {
    introModal.addEventListener('click', (e) => {
      if (e.target === introModal) openFinalView();
    });
  }

  // Watch Now でイントロを再表示
  if (watchNowBtn) {
    watchNowBtn.addEventListener('click', () => {
      if (finalView)   finalView.classList.remove('active');
      if (introModal)  introModal.classList.add('active');
    });
  }

  // ========== 画像モーダル ==========
  const imageModal = $('#imageModal');
  const modalImage = $('#modalImage');
  const loopImages = $$('.loop-slider img');

  if (imageModal && modalImage && loopImages.length) {
    loopImages.forEach(img => {
      img.addEventListener('click', () => {
        modalImage.src = img.src;
        imageModal.classList.add('active');
      });
    });
    imageModal.addEventListener('click', () => {
      imageModal.classList.remove('active');
      modalImage.src = '';
    });
  } else {
    // 必要な要素がなければ何もしない（開発用の注意）
    // console.warn('画像モーダルの要素が見つかりませんでした。');
  }
});

/*
=============================
使い方メモ
-----------------------------
■ カウントを最初からやり直す
  コンソールで：
  localStorage.removeItem('initialAccessMs'); location.reload();

■ 本番で「飛ばさず」見た目だけ確認
  URL末尾に ?nojump を付けて開く

■ 即終了テスト
  ?expireNow    （+ ?nojump で遷移せずUIだけ確認）

■ 締切の変更
  DUE_DAYS_AFTER_FIRST_VISIT を変更（例：1日にしたいなら 1）

■ 別キャンペーンとして新規カウント開始にしたい
  STORAGE_KEY を 'initialAccessMs-v2' のように変える
=============================
*/
